import { BAOCustomElement } from '@bao/custom-element'

class FooterAccordion extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl === clickedTriggerEl) {
        if (triggerEl.classList.contains('ft-Navigation_Title-open')) {
          triggerEl.classList.remove('ft-Navigation_Title-open')
        } else {
          triggerEl.classList.add('ft-Navigation_Title-open')
        }
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.classList.remove('ft-Navigation_Title-open')
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        if (contentEl.classList.contains('ft-Navigation_Expand-open')) {
          contentEl.classList.remove('ft-Navigation_Expand-open')
        } else {
          contentEl.classList.add('ft-Navigation_Expand-open')
        }
      } else if (this.dataset.type === 'oneopen') {
        contentEl.classList.remove('ft-Navigation_Expand-open')
      }
    })
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion)
}
